import Sprite from "./Sprite";
import SpriteAnimation from "./SpriteAnimation";
import SpriteAnimationManager from "./SpriteAnimationManager";

export default class GervaisSpriteAnimation extends SpriteAnimation {
    /**
     * @param {Array.<Sprite>} sprites
     * @param {SpriteAnimationManager} spriteAnimationManager
     * @param {boolean} fastAnimation
     * @param {boolean} loopingAnimation
     */
    constructor(sprites, spriteAnimationManager, fastAnimation, superFastAnimation, directional) {
        super(sprites, spriteAnimationManager, fastAnimation, true);

        /**
         * @constant
         * @type {boolean}
         */
        this.directionalSprite = directional;
        /**
         * @constant
         * @type {boolean}
         */
        this.superFastAnimation = superFastAnimation;

    }

    // /**
    //  * @override
    //  * @returns {Sprite}
    //  */
    // getSprite() {
    //     const frameIndex = this.fastAnimation
    //             ? this.spriteAnimationManager.getFastFrameIndex(0, this.sprites.length) // <-- this takes 4 parameters!
    //             : this.spriteAnimationManager.getFrameIndex(0, this.sprites.length);  // <-- this takes 4 parameters!
    //     return this.sprites.get(frameIndex);
    // }

    /**
     * @override
     * @param {number} currentTime 
     * @param {number} startTime 
     * @returns {Sprite}
     */
    getSpriteAsOf(currentTime, startTime) {
        if (this.fastAnimation) {
            return this.getFastCurrentSpriteAsOf(currentTime, startTime);
        }
        else if (this.superFastAnimation) {
            return this.getSuperFastCurrentSpriteAsOf(currentTime, startTime);
        }
        else {
            return this.getCurrentSpriteAsOf(currentTime, startTime);
        }
    }

    /**
     * @param {number} startTime 
     * @returns {boolean}
     */
    isAnimationLoopCompleted(startTime) {
        if (this.directionalSprite) {
            return false;
        }

        if (this.fastAnimation) {
            return this.spriteAnimationManager.isFastAnimationLoopCompleted(Date.now(), startTime, this.sprites.length);
        }
        else if (this.superFastAnimation) {
            return this.spriteAnimationManager.isSuperFastAnimationLoopCompleted(Date.now(), startTime, this.sprites.length);
        }
        else {
            return this.spriteAnimationManager.isDefaultAnimationLoopCompleted(Date.now(), startTime, this.sprites.length);
        }
    }

    /**
     * @override
     * @returns {boolean}
     */
    isDirectionalSprite() {
        return this.directionalSprite;
    }

}